import { getEmployeeBulkSession } from "../../infrastructure/repository/employees-repository";
import { translate } from "../../infrastructure/translate/localization";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { showErrorMessage } from "../commons/show-error-message";
import { logError, addContextLog } from "../../infrastructure/log";

export async function getCurrentEmployeeBulkSession() {
  try {
    const companyId = await findCompanyId();
    const { data: employees } = await getEmployeeBulkSession(companyId);
    addContextLog("info", "getEmployeeBulkSession", "display-screen", {
      companyId,
    });
    return employees;
  } catch (e) {
    logError(e, `Error to getEmployeeBulkSession`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
    return null;
  }
}
